import { ArrowRight, Code2, GitPullRequest, RefreshCcw, Wrench } from "lucide-react";

const signals = [
  [Wrench, "面向工程"],
  [Code2, "可复现"],
  [RefreshCcw, "持续更新"],
  [GitPullRequest, "开源协作"],
] as const;

export function Hero() {
  return (
    <section className="hero" id="overview" aria-labelledby="hero-title">
      <div className="hero-copy">
        <h1 id="hero-title">Agent Harness 工程阅读库</h1>
        <p className="hero-subtitle">三篇来源，三份独立中文知识文档</p>
        <div className="hero-actions">
          <a className="primary-button" href="#knowledge-map">
            选择文档 <ArrowRight aria-hidden="true" />
          </a>
        </div>
      </div>
      <div className="hero-context">
        <p>
          这不是一篇把来源拼在一起的长文。三份文档分别处理工程 Bot 团队、
          Harness 自我改进研究和持续角色 Bot 的产品使用边界；每份都有自己的
          正文、PDF、来源链接与可独立阅读的目录。
        </p>
        <ul className="signal-list" aria-label="项目特征">
          {signals.map(([Icon, label]) => (
            <li key={label}>
              <Icon aria-hidden="true" />
              <span>{label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
